/**
 * Generic retry helper with exponential back-off.
 *
 * `fn` is called with the current attempt index (0-based).
 * If it throws/rejects, we wait `baseDelay * (attempt + 1)` ms and try again,
 * up to `attempts` times. The final rejection is propagated to the caller.
 *
 * @param {(attempt:number)=>Promise<any>} fn
 * @param {{attempts?:number, baseDelay?:number}} opts
 */
export default async function withRetry(
  fn,
  { attempts = 3, baseDelay = 1000 } = {},
) {
  let lastErr;
  for (let i = 0; i < attempts; i += 1) {
    try {
      return await fn(i);
    } catch (err) {
      lastErr = err;
      if (i < attempts - 1) {
        /* eslint-disable no-await-in-loop */
        await new Promise(r => setTimeout(r, baseDelay * (i + 1)));
      }
    }
  }
  throw lastErr;
}